import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-cftv',
    template: '<router-outlet></router-outlet>',
})
export class CftvComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }
}
